/*
 * @Description: 结算中心中通用字段
 * @Date: 2021-04-30 15:41:09
 */

import {
  listNoPayOrderPeopleAndSuppliePeople,
  totalNoPayOrderPeopleAndSuppliePeople,
  listPayOrderPeopleAndSuppliePeople,
  totalPayOrderPeopleAndSuppliePeople,
  listInvalidPayOrderPeopleAndSuppliePeople,
  totalInvalidPayOrderPeopleAndSuppliePeople
} from '@/api/ajax.js';
import { moneyFixed } from '@/tools/money';
import { userEnterpriseTypeMapping } from '../mapping';

// 结算总价列表 带入了相关接口与参数： 部分/已支付/失效
export const projectPriceHanderl = type => {
  const projectPriceHanderlMap = {
    2: {
      getList: listNoPayOrderPeopleAndSuppliePeople,
      getPrice: totalNoPayOrderPeopleAndSuppliePeople
    },
    3: {
      getList: listPayOrderPeopleAndSuppliePeople,
      getPrice: totalPayOrderPeopleAndSuppliePeople
    },
    4: {
      getList: listInvalidPayOrderPeopleAndSuppliePeople,
      getPrice: totalInvalidPayOrderPeopleAndSuppliePeople
    }
  };
  return {
    label: '结算总价',
    prop: 'projectPrice',
    width: '120px',
    render(h, ctx, row) {
      let {
        csoCustomOrderIds,
        supplierId,
        finishSumTaskPrice,
        discountPrice,
        projectPrice
      } = row;
      const vm = ctx.parent;
      const handler = () => {
        vm.$xrkDialog({
          title: '打款总金额',
          showConfirm: false,
          cancelText: '关闭',
          $slots: {
            default: h(
              require('@/page/settlementCenter/orderMgmt/child/settlementTotalList/index.vue')
                .default,
              {
                props: {
                  ...projectPriceHanderlMap[type],
                  sourceType: type,
                  vm,
                  taskDt: row.taskDt,
                  csoCustomOrderSupplierId: row.id + '',
                  csoCustomOrderIds:
                    csoCustomOrderIds || vm.defaultQuery.csoCustomOrderIds // 深层嵌套弹层中使用csoCustomOrderIds
                }
              }
            )
          }
        });
      };
      return (
        <div>
          {supplierId && (
            <div class="orderPrice">
              <el-button type="text" onClick={handler}>
                {moneyFixed(projectPrice)}
              </el-button>

              {discountPrice > 0 && (
                <el-popover
                  trigger="hover"
                  placement="right"
                  style={{ width: '200px', height: '50px' }}
                >
                  <div style={{ width: '200px', height: '50px' }}>
                    <div>应付：{moneyFixed(finishSumTaskPrice)}</div>
                    <div>优惠：{moneyFixed(discountPrice)}</div>
                    <div>实付：{moneyFixed(projectPrice)}</div>
                  </div>
                  <img
                    slot="reference"
                    src="http://cdn.yxvzb.com/WEB/SaaS/images/coupon.svg"
                    style={{ width: '50px', height: '15px' }}
                  />
                </el-popover>
              )}
            </div>
          )}
          {/* 无供应商不可点 */}
          {!supplierId && <span> {moneyFixed(projectPrice)}</span>}
        </div>
      );
    }
  };
};

export const individualEnterpriseName = {
  label: '个体名称',
  prop: 'individualEnterpriseName'
};

export const individualName = {
  label: '项目参与人',
  prop: 'userName'
};

export const userEnterpriseType = {
  label: '项目参与人类型',
  prop: 'userEnterpriseType',
  width: '120px',
  formatter(r, c, v) {
    return (userEnterpriseTypeMapping[v] || { label: '-' }).label;
  }
};
export const agreementServiceActivityName = {
  label: '关联活动',
  prop: 'agreementServiceActivityName',
  width: '120px'
};
